import React from 'react';
import moment from 'moment';
import EditIcon from "../../../../assets/images/Edit-icon.png";
import { useHistory } from 'react-router-dom';
import { setEditTaskDetails } from '../../AxiosRtk/Tasks';
import { useDispatch } from 'react-redux';

function getStatus(status) {
    if (status === 0) {
        return ['PARENT_TASK_BUTTON_PENDING', 'Pending']
    } else if (status === 1) {
        return ['COMPLETED', 'Completed']
    } else if (status === 2) {
        return ['PARENT_TASK_BUTTON_CONFIRMED', 'Confirmed']
    }
}

function getColor(status) {
    if (status === 0) {
        return 'warning'
    } else if (status === 1) {
        return 'success'
    } else if (status === 2) {
        return 'success'
    }
}

const TaskRow = ({ 
    item, 
    getLangTranslation, 
    handleImageClick, 
    handleSelectChange, 
    kidId, 
    checkSubsciption 
}) => {
    const history = useHistory();
    const dispatch = useDispatch();

    function handleEditTask() {
        if(!checkSubsciption()) {
            return;
        }
        const payload = {
            taskKidId: kidId,
            taskId: item?.ID,
            taskName: item?.taskName,
            taskDetail: item?.taskDetail,
            taskStartTime: item?.startTime,
            taskEndTime: item?.endTime
        }
        dispatch(setEditTaskDetails(payload))
        history.push('/edit-task')
    }

    return (
        <tr key={item?.ID}>
            <td className='v-middle'>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={item?.isChecked}
                        id="taskName1"
                        name={item?.ID}
                        onChange={(e) => handleSelectChange(e)}
                    />
                    <label className="form-check-label" htmlFor="taskName1">
                        {item?.taskName}
                    </label>
                </div>
            </td>
            <td className='v-middle fw-semibold'>{item?.taskDetail}</td>
            <td className='v-middle text-gray-700'><span className='text-small'>{`${item?.startTime} - ${item?.endTime}`}</span></td>
            <td className='v-middle text-nowrap text-gray-700'><span className='text-small'>{moment(item?.dateCreated)?.utc()?.locale('en')?.format("DD-MMM-YYYY | HH:mm")}</span></td>
            <td className='v-middle'><span className={`badge-pill ${getColor(item?.status)}`}>{getLangTranslation(getStatus(item?.status)[0], getStatus(item?.status)[1])}</span></td>
            <td
                className='v-middle d-flex align-items-center justify-content-end me-3 gap-6'
            >
                <i
                    className='icon-placeholder-check text-blue-800 fs-4 pt-cursor'
                    onClick={() => handleImageClick(item?.ID)}
                />
                {
                    item?.status !== 2 && (
                        <i className='icon-edit-one text-blue-800 fs-6 pt-cursor' onClick={handleEditTask} />
                    )
                }
            </td>
        </tr>
    )
}

export default TaskRow